// @ts-ignore
require.config({
    shim: {
        'bootstrap/dropdown': {
            deps: ['jquery'],
            exports: 'jQuery.fn.dropdown.Constructor',
        },
        'bootstrap/modal': {
            deps: ['jquery'],
            exports: 'jQuery.fn.modal.Constructor',
        },
        'bootstrap/tooltip': {
            deps: ['jquery', 'bootstrap/transition'],
            exports: 'jQuery.fn.tooltip.Constructor',
        },
        'bootstrap/transition': {
            deps: ['jquery'],
            exports: 'jQuery.support.transition',
        },
        'fotorama': {
            deps: ['jquery'],
        },
        'headroom': {
            exports: 'Headroom',
        },
    },
    paths: {
        '@google/markerclustererplus': 'node_modules/@google/markerclustererplus/dist/markerclustererplus.umd.js?1',
        '@googlemaps/js-api-loader': 'node_modules/@googlemaps/js-api-loader/dist/index.cjs?1',
        'backbone': 'node_modules/backbone/backbone-min',
        'bootstrap': 'node_modules/bootstrap/js',
        'bootstrap/slider': 'node_modules/bootstrap-slider/dist/bootstrap-slider.min',
        'fotorama': 'node_modules/fotorama/fotorama',
        'headroom': 'node_modules/headroom.js/dist/headroom.min',
        'jquery': 'node_modules/jquery/dist/jquery.min',
        'nprogress': 'node_modules/nprogress/nprogress',
        'odometer': 'node_modules/odometer/odometer.min',
        'pdfobject': 'node_modules/pdfobject/pdfobject.min',
        'require/async': 'node_modules/requirejs-plugins/src/async',
        'sightglass': 'node_modules/sightglass/index',
        'typeahead': 'components-custom/typeahead-amd',
        'underscore': 'node_modules/underscore/underscore-min',
    },
});

if ('customElements' in window) {
    // @ts-ignore
    require(['views/app'], function (app) {

        // @ts-ignore
        window.GA = new app.default();
        // @ts-ignore
        window.GA.run();

        let expires = new Date();
        expires.setMonth(expires.getMonth() + 1);
        let ch = 'CH=' + encodeURIComponent('DPR=' + window.devicePixelRatio + ',Viewport-Width=' + window.screen.width) + '; expires=' + expires.toUTCString() + '; path=/pictures';
        document.cookie = ch;
    });
}
;
define("main", function(){});

